import React, { useContext, useEffect, useState } from 'react';
import {makeStyles, Toolbar, useTheme} from '@material-ui/core';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import PageToolbar from '../components/pageToolbar';
import AutoTable from '../components/autoTable';
import { secsToTimeStr } from '../global/dateTimeHelpers';
import API from '../global/api';
import globalContext from '../context/globalContext';
import DateFnsUtils from '@date-io/date-fns';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import ProgressButton from '../components/progressButton';
import DownloadButton from '../components/downloadButton';
import { localeCurrency, formatConsumptionValue, getUnitLabel, getConsumptionHeader } from '../global/helpers';
import { SQLtoUTCDate } from '../global/dateTimeHelpers';
import SearchInput from '../components/searchInput';

const headCells = ["customer","boat_name","service_type","total_time","consumption","unit","revenue","currency"]

const useStyles = makeStyles(theme => ({
  container: {
    width: '100%',
    minHeight: '100%',
    flex: 1,
    display: 'flex',
    flexDirection: 'column'
  }
}))

const ReportUsage = props => {

  const theme = useTheme();
  const classes = useStyles(theme);
  const context = useContext(globalContext);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [ startDate, setStartDate ] = useState(new Date(new Date().setTime(new Date().getTime() - (7 * 24 * 60 * 60 * 1000))));
  const [ endDate, setEndDate ] = useState(new Date());

  const formatConsumptionOnly = (val, idx) => {
    const row = data[idx];
    if(typeof row !== 'undefined') {
      return formatConsumptionValue(val, row.id_unit);
    }
    return val;
  }

  const getUnit = (idx) => {
    const row = data[idx];
    if(typeof row !== 'undefined') {
      return getUnitLabel(row.id_unit);
    }
    return '';
  }

  const handleLoadReport = () => {

    if(typeof context.profile.data.id_organisation !== 'undefined'){
      setLoading(true);
  
      const params = {
        start: startDate,
        end: endDate,
      };
      if (searchTerm) {
        params.search = searchTerm;
      }

      API.req(`/services/usage/${context.profile.data.id_organisation}`, 'GET', params).then(
        async res => {
          setLoading(false);
          setData(res.result);
        },
        err => {
            setLoading(false);
            context.showSnack({message: typeof err === 'string' ? err : JSON.stringify(err)}, 'error')
        }
      )
    }

  }

  const getCurrency = (idx) => {
    const record = data[idx];
    if(typeof record !== 'undefined')
      return record.currency;
    else
      return context.profile.data.currency;
  }

  useEffect(() => {
    handleLoadReport();
  }, [context.profile])

  useEffect(() => {
    handleLoadReport();
  }, [searchTerm])

  return (
    <div className={classes.container}>

      <PageToolbar label="Usage Report"></PageToolbar>
      
      <Toolbar disableGutters={true} style={{display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap'}}>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <KeyboardDatePicker
            margin="normal"
            id="date-picker-start"
            label="Start"
            format="dd/MM/yyyy"
            inputVariant="standard"
            KeyboardButtonProps={{
              'aria-label': 'change date',
            }}
            value={startDate}
            onChange={d => setStartDate(d)}
          />
          <KeyboardDatePicker
            margin="normal"
            id="date-picker-end"
            label="End"
            format="dd/MM/yyyy"
            inputVariant="standard"
            KeyboardButtonProps={{
              'aria-label': 'change date',
            }}
            value={endDate}
            onChange={d => setEndDate(d)}
          />
        </MuiPickersUtilsProvider>
        <div style={{marginTop: '16px'}}>
          <SearchInput
            onSearch={(term) => setSearchTerm(term)}
            onClear={() => setSearchTerm('')}
            placeholder="Search customer or boat..."
          />
        </div>

        <div style={{marginTop: '16px'}}>
          <ProgressButton waiting={loading} variant="contained" color="default" onClick={handleLoadReport}>Generate</ProgressButton>
        </div>
        <div style={{flex: 1}}></div>

        <div style={{marginTop: '16px'}}>
          <DownloadButton
            waiting={downloading}
            variant="contained"
            color="default"
            data={data}
            orderBy="customer"
            headCells={headCells}
            fileName={`usage`}
            cellReplacementProps={{
              'total_time': (val, idx) => secsToTimeStr(val),
              'revenue': (val, idx) => localeCurrency(val),
              'consumption': (val, idx) => formatConsumptionOnly(val, idx),
              'unit': (_val, idx) => getUnit(idx),
            }}
            handleError={(error) => console.log(error)}
          />
        </div>
        </Toolbar>

      <AutoTable
        rows={data}
        orderBy="customer"
        headCells={headCells}
        loading={context.services.status === 'LOADING'}
        cellReplacementProps={{
          'total_time': (val, idx) => secsToTimeStr(val),
          'revenue': (val, idx) => <b>{localeCurrency(val)}</b>,
          'consumption': (val, idx) => formatConsumptionOnly(val, idx),
          'unit': (_val, idx) => getUnit(idx),
        }} />

    </div>
  );
}

export default ReportUsage;
